// extracted by mini-css-extract-plugin
export default {"bookmark":"BookmarkContent_bookmark__QwRiR","unbookmark":"BookmarkContent_unbookmark__iABMA"};